import FooterImg from "../assets/img/bg/bg-footer.jpg";
import logo from "../assets/img/logo/Logo Outlined.png";
import { Link } from "react-router-dom";

export const NavLinks = [
  {
    name: "Home",
    url: "/",
  },
  {
    name: "About",
    url: "/about",
  },
  {
    name: "Tracking",
    url: "/Tracking",
  },
  {
    name: "Services",
    url: "/services",
  },
  {
    name: "Contact",
    url: "/contact",
  },
];

export default function Footer() {
  return (
    <footer
      class="footer pos-rel overflow-hidden hero-bg"
      style={{ backgroundImage: `url(${FooterImg})` }}
    >
      <div class="footer-up de-padding">
        <div class="container">
          <div class="row g-5">
            <div class="col-xl-4 col-lg-6 col-md-6">
              <div class="footer-widget about-us">
                <div class="footer-logo mb-30">
                  <img src={logo} alt="no image" />
                </div>
                <p className="m-0">
                  Our goal is to become the industry's leading logistics and
                  supply chain service provider in Erbil by delivering
                  innovative, efficient, and cost-effective solutions and
                  achieving excellence in serving our clients.
                </p>
              </div>
            </div>
            <div class="col-xl-2 col-lg-6 col-md-6">
              <div className="footer-widget footer-link">
                <h4 className="footer-widget-title">
                  Useful Links
                  <span className="footer-title-line"></span>
                </h4>
                <ul className="footer-list">
                  {NavLinks.map((link, index) => (
                    <li key={index}>
                      <Link to={link.url}>
                        <i className="fa-solid fa-chevron-right"></i>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div class="col-xl-3 col-lg-6 col-md-6">
              <div class="footer-widget pr-30">
                <h4 class="footer-widget-title">
                  Working Hours
                  <span class="footer-title-line"></span>
                </h4>
                <p class="mb-30">
                  We work 6 days a week and 1 day off.Contact us for any info.
                </p>
                <ul class="footer-hours">
                  <li>
                    <span>Saturday :</span> <span>8.00 - 16.00</span>{" "}
                  </li>
                  <li>
                    <span>Sun - Wed :</span> <span>9.00 - 16.00</span>{" "}
                  </li>
                  <li>
                    <span>Thursday :</span> <span>10.00 - 16.30</span>{" "}
                  </li>
                  <li>
                    <span>Friday :</span> <span>Closed</span>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div class="col-xl-3 col-lg-6 col-md-6">
						<div class="footer-widget">
							<h4 class="footer-widget-title">
								Newsletter
								<span class="footer-title-line"></span>
							</h4>
							<p class="mb-30">
								Subscribe our newsletter to get our latest update &amp;
								news
							</p>
							<div class="subscribe-area">
								<form>
									<span class="btn-shape"></span>
									<input type="text" class="input-style-4" placeholder="Enter Email..." />
									<button type="submit" class="btn-subs">
										<i class="fa-solid fa-chevron-right"></i>
									</button>
								</form>
							</div>
						</div>
					</div> */}
          </div>
        </div>
      </div>
      <div class="copyright py-5">
        <div class="container">
          <div class="copyright-element d-flex align-items-center justify-content-between">
            <p class="mb-0">
              Copyright 2023 Hallgord . All Rights Reserved By Syndrem
            </p>
            <ul class="footer-social">
              <li>
                <a href="#">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
